import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { UserStockModel } from './userStock.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { UserCompanyService } from '../usercompany/usercompany.service';
import { MatDialog } from '@angular/material/dialog';
import { UserStockComponent } from './userStock.component';
import { UserStockService } from './userStock.service';
import { consts } from '../../../consts';

@Component({
    selector: 'convfact-userStock-login',
    templateUrl: './userStock-login.component.html',
    styleUrls: [],
    standalone: false
})

export class UserStockLoginComponent implements OnInit {
  userName: string;
  password: string;
  loginSpinner: boolean = false;
  showNewPassword: boolean = false;

  constructor(
    private userStockService: UserStockService,
    public dialogRef: MatDialogRef<UserStockComponent>,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  showPassword(input: any): any {
    input.type = input.type === 'password' ? 'text' : 'password';
    this.showNewPassword = !this.showNewPassword;
  }

  generarToken() {
    if (this.userName == null) {
      this.displayInfo("Debe especificar el nombre del usuario");
    } else {
      if (this.password == null) {
        this.displayInfo("Debe especificar la contraseña");
      } else {
        this.loginSpinner = true;

        this.userStockService.login(this.userName, this.password).then(response => {
          this.loginSpinner = false;
          if (response.code == consts.STATUS_OK.toString()) {
            this.dialogRef.close({ token: response.content.token, expired: response.content.expired });
          } else {
            this.displayInfo(response.error);
          }
        })
          .catch(errors => {
            this.loginSpinner = false;
          });
      }
    }
  }
}
